export default "__VITE_ASSET__BNTupWXL__"